import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class AssignementUserAppointmentExcel {
    exportExcel(data, fecha_inicial, fecha_final, cantidadTotal) {
        let option = {};  // La opción representa el archivo de Excel
        let assignetmentsUsers = this.assignetmentsUsers(data, fecha_inicial, fecha_final, cantidadTotal);
        option.fileName = 'Asignacion Citas Usuario';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: assignetmentsUsers.data,  // Fuente de datos en archivo Excel
                sheetName: 'Asignacion Citas Usuario',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
        
    }

    assignetmentsUsers(assigmentUserData, fecha_inicial, fecha_final, cantidadTotal) {

        let dataTable = [];  // Contenido de datos en archivo Excel
        let CasillasFecha = this.generarCasillasFecha(fecha_inicial,fecha_final);//Casillas Vacias y Preconfiguradas
        dataTable.push(CasillasFecha);

        let CasillaVacia = this.generarCasillaVacias();//Casillas Vacias y Preconfiguradas
        dataTable.push(CasillaVacia);

        let CasillaTitulos = this.generarCasillaTitulos();//Casillas Vacias y Preconfiguradas
        dataTable.push(CasillaTitulos);

        for(let i = 0; i < assigmentUserData.length; i++)
        {
            let dataCasilla = this.generarCasillaData(assigmentUserData[i],cantidadTotal);
            dataTable.push(dataCasilla);
        }

        dataTable.push(CasillaVacia);

        let CasillaTotales = this.generarCasillaTotales(cantidadTotal);
        dataTable.push(CasillaTotales);
        
        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarCasillasFecha(fecha_inicial,fecha_final) {
        let casillas = {
            '1': `Reporte de Asignación de Citas por Usuario - Periodo del ${moment(fecha_inicial).format("DD/MM/YYYY")} al ${moment(fecha_final).format("DD/MM/YYYY")}`
        }
        return casillas;
    }

    generarCasillaVacias() {
        let casillas = {
            '1': ``
        }
        return casillas;
    }

    generarCasillaTitulos() {
        let casillas = {
            '1': 'Usuario',
            '2': 'Cantidad',
            '3': 'Porcentaje'
        }
        return casillas;
    }

    generarCasillaData(data,cantidadTotal) {
        let casillas = {
            '1': data.nombre_usuario != null && data.nombre_usuario != undefined ? data.nombre_usuario : "",
            '2': data.cantidad != null && data.cantidad != undefined ? data.cantidad : "",
            '3': `${this.hallarPorcentaje(cantidadTotal,data.cantidad).toFixed()} %`
        }
        return casillas;
    }

    generarCasillaTotales(total) {
        let casillas = {
            '1': 'Total Asignación de Citas',
            '2': total
        }
        return casillas;
    }

    hallarPorcentaje (cantidadTotal,cantidadUsuario)
    {
        let porcentaje = (parseInt(cantidadUsuario) / parseInt(cantidadTotal)) * 100;
        return porcentaje;
    }
}

export default new AssignementUserAppointmentExcel();